import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
    >
      <div className="relative w-full sm:w-48 h-28 rounded-lg overflow-hidden bg-background-200 shrink-0">
        <img
          src={article.cover}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={article.title}
        />
      </div>

      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-medium text-foreground-100 group-hover:text-accent-500 transition-colors line-clamp-2 mb-1.5 leading-snug">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-600 flex-wrap">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {(article.views / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
    </Link>
  );
}